export const menuLinks =
  [
    {
      "label": "menu.dashboard",
      "link": "/dashboard",
      "submenu": [

        {
          "label": "menu.welcomeDashboard",
          "link": "/dashboard/summary-dashboard"
        },
        {
          "label": "menu.mobileDevices",
          "link": "/dashboard/deviceslist/mobile-devices"
        },
        {
          "label": "menu.accessPoints",
          "link": "/dashboard/aps"
        },
        {
          "label": "menu.licenseSummary",
          "link": "/dashboard/license-summary"
        },
      ]
    },
    {
      "label": "menu.settings",
      "link": "/settings",
      "dividerNeeded": true,
      "submenu": [

        //New
        {
          "label": "menu.subMenu.manageKiosks",
          "link": "/settings/manage-kiosk",
          "dividerNeeded": true
        },
        {
          "label": "menu.subMenu.manageKioskDevice",
          "link": "/settings/kiosk-device",
          "dividerNeeded": true
        },
        {
          "label": "menu.subMenu.ssoSettings",
          "link": "/settings/ssoint/sso"
        },
        {
          "label": "menu.subMenu.site",
          "link": "/settings/site",
          "dividerNeeded": true
        },
        {
          "label": "menu.subMenu.manageUsers",
          "link": "/settings/manage-users",
          "dividerNeeded": true
        },
        {
          "label": "menu.subMenu.registration",
          "link": "/settings/device-registration"
        },
        {
          "label": "menu.subMenu.automation",
          "link": "/settings/workflow-automation"
        },
        {
          "label": "menu.notifications",
          "link": "/settings/notifications"
        },
        {
          "label": "menu.subMenu.gpsLocation",  // menu label displayed under Settings in Web Portal
          "link": "/settings/gps-location"
        },//BT Scanner Tracking Feature toggling enabled
        {
          "label": "menu.subMenu.btScanners",  // menu label displayed under Settings in Web Portal
          "link": "/settings/btscanners"
        }
      ]
    },
    ,
    {
      "label": "report.reports",
      "link": "/reports",
      "dividerNeeded": true,
      "submenu": [
        {
          "label": "devices",
          "link": "/reports/devices"
        },
        {
          "label": "report.historicalReports",
          "link": "/reports/historical-reports"
        },
        {
          "label": "report.eventsBySite",
          "link": "/reports/daily-event-detail-report"
        },
        // {
        //   "label": "Checkout Events By Device",
        //   "link": "/reports/daily-event-summary-report"
        // },
        // {
        //   "label": "Utilization By Device",
        //   "link": "/reports/device-utilization-summary"
        // },
        // {
        //   "label": "Checkout History",
        //   "link": "/reports/device-utilization-detail"
        // },
        {
          "label": "eodDeviceSummary",
          "link": "/reports/end-of-day-summary"
        }
        // ,
        // {
        //   "label": "End of Day Device Detail",
        //   "link": "/reports/end-of-day-detail"
        // }



      ]
    }
    ,
    {
      "label": "menu.helpMenu",
      "link": "/helpdoc",
      "dividerNeeded": true
    },
    {
      "label": "menu.about",
      "link": "/about",
      "dividerNeeded": true
    }
  ];

export const dlrMenuReplace = {
  "menu.subMenu.automation": {
    "label": "menu.subMenu.automation",
    "link": "/settings/auto",
    "submenu": [
      {
        "label": "menu.subMenu.thresholdsAndRules",
        "link": "/settings/auto/workflow-automation"
      },
      {
        "label": "menu.subMenu.machineLearning",
        "link": "/settings/auto/MachineLearning"
      }
    ]
  }
}